var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfIcon = function SvgPdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21.76,
    "data-name": "Group 2513",
    viewBox: "0 0 17 21.76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8e8dbe",
    d: "M17 20.436V6.627a.7.7 0 0 0-.013-.129.7.7 0 0 0-.058-.165q-.01-.02-.021-.04a.7.7 0 0 0-.106-.146L10.851.198a.7.7 0 0 0-.146-.106l-.04-.021a.7.7 0 0 0-.164-.058.7.7 0 0 0-.13-.013H1.364a1.36 1.36 0 0 0-1.36 1.36V20.4a1.36 1.36 0 0 0 1.36 1.36l14.305-.023a1.337 1.337 0 0 0 1.335-1.337H1.364V1.359h8.33v4.59a1.36 1.36 0 0 0 1.36 1.36h4.59v13.127m-4.59-14.487V2.32l3.627 3.633Z",
    "data-name": "Path 928"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#8e8dbe",
    "data-name": "Group 1602",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.791 10.858h1.614a1.108 1.108 0 1 1 0 2.214h-.88v1.235H3.79Zm1.516.631h-.781v.952h.781a.477.477 0 1 0 0-.952",
    "data-name": "Path 929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.018 10.858h1.359a1.728 1.728 0 1 1 0 3.45H7.018Zm1.359 2.8a1.03 1.03 0 0 0 1.08-1.075 1.01 1.01 0 0 0-1.08-1.081h-.626v2.156Z",
    "data-name": "Path 930"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.736 10.858h2.44v.631H11.47v.75h1.671v.631H11.47v1.437h-.733Z",
    "data-name": "Path 931"
  }))));
};
export default SvgPdfIcon;